import Head from "next/head";
import Navbar from "../../components/general/Navbar";
import Header from "../../components/general/Header";
import HiddenMenu from "../../components/general/HiddenMenu";
import Footer from "../../components/general/Footer";
import React, {useState, useEffect} from "react";
import AuthServices from "../../services/Auth.services";
import parse from "html-react-parser";

export default function Projects({navigation, loggedIn, jwtToken, pageData}) {
    const [userInfo, setUserInfo] = useState();

    useEffect(() => {
        if (!jwtToken) {
            return;
        }
        setUserInfo(AuthServices.getUserData(jwtToken));
    }, []);

    return (
        <div className="min-h-screen flex flex-col">
            <Head>
                <title>Olaf Nijenkamp | Projecten</title>
                <meta name="description" content="Generated by create next app"/>
            </Head>

            <header>
                <Navbar items={navigation}/>
                <HiddenMenu loggedIn={loggedIn} role={userInfo?.role}/>
                <Header title={"Projecten"} small={true} customStyles="pb-8 lg:pb-20"/>
            </header>

            <main className="px-4 z-10 bg-olaf-green-300">
                <div className={"olafGrid block !my-10 md:!my-20"}>
                    <div className={"lg:max-w-5xl"}>
                        <h2>HOVENIERS | Werk in uitvoering</h2>
                        <p>
                            Van exclusieve tuin tot fraaie bloembak. We zijn geworden wat we zijn dankzij een continue
                            stroom van kleine en grote opdrachten: elk nieuw groenproject zien wij als een mooie
                            opdracht. Onze chauffeurs leveren bomen en planten op locatie en maken regelmatig foto’s van
                            geleverde bomen en planten bij hoveniers, grootgroenbedrijven en gemeentes. Ook ontvangen we
                            regelmatig updates van klanten na een levering of na aanplant.
                        </p>
                    </div>
                </div>

                <div className={"grid olafGrid gap-8 projectsOverviewGrid"}>
                    {pageData.map(({url, text, imageUrl}, i) => (
                        <div
                            key={i}
                            className={`relative h-[180px] md:h-[370px] w-full flex items-end transition-width duration-300 ease-in-out group`}
                        >
                            <a href={url}>
                                <h3
                                    className={`text-white relative z-30 font-bold lg:text-2xl m-6 transition duration-300 ease-in-out`}
                                >
                                    {text}
                                </h3>
                                <div
                                    className={`projectBlockOverlay transition duration-300 ease-in-out`}
                                ></div>
                                <img
                                    src={imageUrl}
                                    className={
                                        "absolute top-0 left-0 w-full h-full object-cover z-10"
                                    }
                                />
                            </a>
                        </div>
                    ))}
                </div>
            </main>

            <Footer/>
        </div>
    );
}

export async function getServerSideProps(context) {
    var loggedIn = !!context.req.cookies["auth"];

    const jwtToken = context.req.cookies["auth"];

    AuthServices.cookieCheck(jwtToken, context);
    await AuthServices.refreshToken(jwtToken, context);

    const {slug} = context.query;

    let foundResult = true;
    const pageData = await fetch(
        process.env.NEXT_PUBLIC_CRAFT_BASE_URL + "/api/projects/",
        {
            method: "get",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        }
    ).then((response) => {
        if (!response.ok) {
            foundResult = false;
            return [];
        }

        return response.json();
    });

    if (foundResult === false) {
        return {
            notFound: true,
        };
    }

    return {
        props: {
            loggedIn: loggedIn || false,
            jwtToken: jwtToken || null,
            pageData: pageData || null,
        }, // will be passed to the page component as props
    };
}
